import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface ImportDutyExportsPayload {
  file: File;
}

export const useAdminImportDutyExports = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: ImportDutyExportsPayload) => {
      const formData = new FormData();
      formData.append('file', payload.file);

      return apiClient.dutyExport.updateTaricDutyExport.mutation({
        body: formData,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-catalogs-info'] });
      toast.success('Duty export imported successfully');
    },
    onError: (error: unknown) => {
      showErrorToast(error, 'Failed to import duty export');
    },
  });
};
